import { createApiBody } from '../../../api/api';
import call from '../../../api/axios';

export async function FetchClassProduct(data) {
	const body = createApiBody(
		'underwriting',
		'product',
		'fetchInsuranceClassProducts',
		{ insuranceClass: data },
	);
	const res = await call.post('', body);

	if (res.status) {
		return { data: res.data, status: true };
	} else {
		return { status: false };
	}
}

export async function FetchClassRecommendations(data) {
	const body = createApiBody(
		'underwriting',
		'product',
		'fetchSystemReccomendation',
		data,
	);
	const res = await call.post('', body);

	if (res.status) {
		return { data: res.data, status: true };
	} else {
		return { status: false };
	}
}

export async function FetchInsuranceClasses() {
	const body = createApiBody('client', 'classes', 'fetch', {});
	const res = await call.post('', body);
	if (res.status) {
		return { data: res.data.result.data, status: true };
	} else {
		return { status: false };
	}
}
export async function FetchClassProductDetails(data) {
	const body = createApiBody(
		'underwriting',
		'product',
		'productWithBenefitsAndUnderwriterDetails',
		{ productSystemRef: data },
	);
	const res = await call.post('', body);

	if (res.status) {
		return { data: res.data.result.data, status: true };
	} else {
		return { status: false };
	}
}
export async function GetCmQuotation(data) {
	const body = createApiBody(
		'underwriting',
		'product',
		'productPremiumCalc',
		data,
	);
	const res = await call.post('', body);
	if (res.status) {
		return { status: true, data: res.data };
	} else {
		return { status: false };
	}
}

export async function CreateQuotationApi(data) {
	const body = createApiBody('client', 'quotation', 'createQuotation', data);
	const res = await call.post('', body);
	if (res.status) {
		return { status: true, data: res.data };
	} else {
		return { status: false };
	}
}

export async function FetchQuotationDetails(data) {
	const body = createApiBody(
		'underwriting',
		'quotation',
		'systemQuotationDetails',
		data,
	);
	const res = await call.post('', body);
	if (res.status) {
		return { status: true, data: res.data };
	} else {
		return { status: false };
	}
}

export async function CompleteQuotation(data) {
	const body = createApiBody(
		'underwriting',
		'quotation',
		'completeQuotation',
		data,
	);

	const res = await call.post('', body);
	if (res.status) {
		return { status: true, data: res.data.result.data };
	} else {
		return { status: false };
	}
}

export async function RequestPayment(data) {
	const body = createApiBody(
		'underwriting',
		'accounting',
		'invoicePaymentRequest',
		data,
	);
	const res = await call.post('', body);
	if (res.status) {
		return { status: true, data: res.data.result.data };
	} else {
		return { status: false };
	}
}

export async function FetchIntermediaries() {
	const body = createApiBody(
		'underwriting',
		'quotation',
		'listIntermediaries',
		{},
	);
	const res = await call.post('', body);
	if (res.status) {
		return { status: true, data: res.data.result.data };
	}
}

export async function CheckPaymentDetails(data) {
	const body = createApiBody(
		'intergration',
		'payment',
		'paymentRequestDetails',
		data,
	);
	const res = await call.post('', body);
	if (res.status) {
		return { status: true, data: res.data.result.data };
	}
}

export async function RequestQuotation(data) {
	const body = createApiBody(
		'underwriting',
		'quotation',
		'clientQuotationRequest',
		data,
	);
	const res = await call.post('', body);
	if (res.status) {
		return { status: true, data: res.data };
	} else {
		return { status: false };
	}
}

export async function AcceptReccommendation(data) {
	const body = createApiBody(
		'underwriting',
		'quotation',
		'acceptReccommendation',
		data,
	);
	const res = await call.post('', body);
	if (res.status) {
		return { status: true, data: res.data.result.data };
	} else {
		return { status: false };
	}
}
export async function RejectQuotation(data) {
	const body = createApiBody(
		'underwriting',
		'quotation',
		'acceptOrRejectQuotationRequest',
		data,
	);
	const res = await call.post('', body);
	if (res.status) {
		return { status: true, data: res.data };
	} else {
		return { status: false };
	}
}

export async function GetQuotationDetails(data) {
	const body = createApiBody(
		'underwriting',
		'quotation',
		'getQuotationDetails',
		data,
	);
	const res = await call.post('', body);
	if (res.status) {
		return { status: true, data: res.data.result.data };
	} else {
		return { status: false };
	}
}
export async function GetDirectQuotationDetails(data) {
	const body = createApiBody('client', 'quotation', 'quotationDetails', data);
	const res = await call.post('', body);
	if (res.status) {
		return { status: true, data: res.data.result.data };
	} else {
		return { status: false };
	}
}

export async function GetValuationDetails(data) {
	const body = createApiBody(
		'underwriting',
		'valuation',
		'requestDetails',
		data,
	);
	const res = await call.post('', body);
	if (res.status) {
		return { status: true, data: res.data.result.data };
	}
}

export async function UpdateValuationAvailbility(data) {
	const body = createApiBody(
		'underwriting',
		'valuation',
		'updateClientAvailability',
		data,
	);
	const res = await call.post('', body);
	if (res.status) {
		return { status: true, data: res.data.result.data };
	}
}
